import React, { useState } from 'react';
import { AlertTitle, CircularProgress, Container, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { green, red } from '@mui/material/colors';
import { useLazyGetAccountActivateQuery } from '../../../entities/account/accountResource/redux/accountResource.api';
import Wrapper from './styles/Wrapper';
import Alert from './styles/Alert';
import Button from './styles/Button';
import StatusAvatar from './styles/StatusAvatar';
import InfoText from './styles/InfoText';

function AccountActivateView() {
  const [searchParams] = useSearchParams();
  const key = searchParams.get('key');

  const [triggerActivate, { isLoading, isError, isSuccess }] = useLazyGetAccountActivateQuery();
  const [requested, setRequested] = useState(false);

  const handleActivate = async () => {
    if (key) {
      await triggerActivate({ params: { key } });
      setRequested(true);
    }
  };

  const avatarColor = isSuccess ? green[500] : isError ? red[500] : '';

  return (
    <Container component="main" maxWidth="sm">
      <Wrapper>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <StatusAvatar color={avatarColor}>
            <LockOpenIcon />
          </StatusAvatar>
        )}
        <Typography component="h1" variant="h5">
          ВИСТАР-М
        </Typography>

        {!requested && (
          <>
            <InfoText>После нажатия кнопки Ваш аккаунт будет активирован</InfoText>
            <Button onClick={handleActivate} variant="contained" disabled={!key || isLoading}>
              Активировать
            </Button>
          </>
        )}
        {isError ? (
          <Alert severity="error">
            <AlertTitle>Ошибка</AlertTitle>
            Не удалось активировать аккаунт
          </Alert>
        ) : isSuccess ? (
          <Alert severity="success">
            <AlertTitle>Успешно</AlertTitle>
            Ваш аккаунт успешно активирован
          </Alert>
        ) : null}
      </Wrapper>
    </Container>
  );
}

export default AccountActivateView;
